module.exports = __webpack_public_path__ + "media/flags/ps-1ff52afa.svg";